import { getElements } from '../Utility/Dom'

class Accordion {
  init(): void {
    this.setDetailsHeight()
  }

  private setDetailsHeight(): void {
    const setHeight = (details: HTMLDetailsElement, open = false) => {
      details.open = open
      const rect = details.getBoundingClientRect()
      details.style.setProperty(open ? '--expanded' : '--collapsed', `${rect.height}px`)
    }

    const details = getElements('accordion-details')

    const resizeObserver = new ResizeObserver(entries => {
      return entries.forEach(entry => {
        const details = entry.target as HTMLDetailsElement

        if (!details.open) {
          details.removeAttribute('style')
          setHeight(details)
          setHeight(details, true)
          details.open = false
        }
      })
    })

    details.forEach(details => {
      resizeObserver.observe(details as HTMLDetailsElement)
    })
  }
}

const accordion = new Accordion()
accordion.init()
